import React from 'react';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import asyncComponent from '../../util/asyncComponent';

import {useSelector} from "react-redux";
// import nprogress from 'nprogress';

import DashboardPages from "./dashboard";
// import SupportPages from "./support";
import CIRTPages from "./cirt";
import BRPortfolioPages from "./brportfolio";
import BRBusinessPages from "./brbusiness";
import PartnerPages from "./partner";
import StaffPages from "./staff";
import AdminPages from "./administrative";
import CompliancePages from "./compliance"
import UsersGuidePage from "./usermanual/UsersGuidePage";
import CIRTUserManual from "./usermanual/CIRTUserManualComponent";
import FAQ from "./extraPages/routes/faq";
import {isCurrentUserMemberOf} from "../../util/bbHelpers";
import UserGuideRoutes from "./usermanual";
import SearchResultsPage from "./search/routes/SearchResultsPage";
import SearchPageRoutes from "./search";

const RestrictedRoute = ({component: Component, authUser, roles=[], ...rest}) => {

    let hasAuthorizedRole = false;
    // console.log("looking at these roles for access to pages", roles)
    for (const role of roles) {
        // console.log("looking at this role", role)
        if (isCurrentUserMemberOf(authUser, role)) {
            // console.log("role found")
            hasAuthorizedRole = true;
            break;
        }
    }

    return <Route
        {...rest}
        render={props =>
            hasAuthorizedRole
                ? <Component {...props} />
                : <Redirect
                    to={{
                        pathname: '/board/settings/account',
                        state: {from: props.location}
                    }}
                />}
    />
};

const Routes = ({match}) => {
    const authUser = useSelector(({auth}) => auth.authUser);
    const isAdmin = isCurrentUserMemberOf(authUser,"admin");
    const isStaff = isCurrentUserMemberOf(authUser,"staff");
    const isPartner = isCurrentUserMemberOf(authUser,"partner");
    const isCustomer = isCurrentUserMemberOf(authUser,"customer");
    const isBRPortfolioCustomer = isCurrentUserMemberOf(authUser,"breachrisk_portfolio");
    const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk");

    // React.useState(nprogress.start());
    //
    // React.useEffect(() => {
    //     nprogress.done();
    //     return () => nprogress.start();
    // });

    //jfd if the auth hasn't come in yet and is null, give the basics:
    if (!authUser) {
        return (
            <Switch>
                {/*<Route path={`${match.url}/faq`} component={asyncComponent(() => import('./extraPages/routes/faq'))}/>*/}
                <Route path={`${match.url}/settings/subscription`} component={DashboardPages}/>
                <Route path={`${match.url}/faq/:section`} component={FAQ}/>
                <Route path={`${match.url}/faq/`} component={FAQ}/>
                <Route path={`${match.url}/contact`} component={asyncComponent(() => import('./extraPages/routes/contactUs'))}/>
                {/*<Route path={`${match.url}/about`} component={asyncComponent(() => import('./extraPages/routes/aboutUs'))}/>*/}
                {/*<Route component={asyncComponent(() => import("app/routes/extraPages/routes/500"))}/>*/}
                <Route path={`${match.url}/userguide`} component={UsersGuidePage}/>
            </Switch>
        )
    }
    // else if (authUser.customers.length < 1) {
    //     return (
    //         <Switch>
    //             <Route path={`${match.url}/dashboard`} component={asyncComponent(() => import('./extraPages/routes/welcomeaboard'))}/>
    //             <Route path={`${match.url}/`} component={asyncComponent(() => import('./extraPages/routes/welcomeaboard'))}/>
    //             <Route path={`${match.url}/welcome`} component={asyncComponent(() => import('./extraPages/routes/welcomeaboard'))}/>
    //             <Route path={`${match.url}/faq`} component={asyncComponent(() => import('./extraPages/routes/faq'))}/>
    //             <Route path={`${match.url}/contact`} component={asyncComponent(() => import('./extraPages/routes/contactUs'))}/>
    //             <Route path={`${match.url}/about`} component={asyncComponent(() => import('./extraPages/routes/aboutUs'))}/>
    //             {/*<Route component={asyncComponent(() => import("app/routes/extraPages/routes/500"))}/>*/}
    //         </Switch>
    //     )
    // }
    else {

        return (
            <Switch>

                <RestrictedRoute authUser={authUser} roles={["breachrisk","breachrisk_portfolio", "admin", "staff"]} path={`${match.url}/BreachRisk/Portfolio`} component={BRPortfolioPages}/>
                <RestrictedRoute authUser={authUser} roles={["breachrisk","breachrisk_portfolio", "admin", "staff"]} path={`${match.url}/BreachRisk/Business`} component={BRBusinessPages}/>
                {/*<RestrictedRoute authUser={authUser} roles={["breachrisk","breachrisk_portfolio", "admin", "staff"]} path={`${match.url}/search`} component={SearchPageRoutes}/>*/}


                {/*<RestrictedRoute authUser={authUser} roles={["customer", "partner", "admin", "staff"]} path={`${match.url}/dashboard`} component={DashboardPages}/>*/}
                <RestrictedRoute authUser={authUser} roles={["customer", "partner", "admin", "staff"]} path={`${match.url}/CIRT`} component={CIRTPages}/>
                <RestrictedRoute authUser={authUser} roles={["customer", "partner", "admin", "staff"]} path={`${match.url}/compliance`} component={CompliancePages}/>

                <RestrictedRoute authUser={authUser} roles={[ "partner", "admin", "staff"]} path={`${match.url}/Partner`} component={PartnerPages}/>

                <RestrictedRoute authUser={authUser} roles={["admin", "staff"]} path={`${match.url}/Staff`} component={StaffPages}/>
                <RestrictedRoute authUser={authUser} roles={["admin", "staff"]}  path={`${match.url}/admin`} component={AdminPages}/>

                <Route path={`${match.url}/settings`} component={DashboardPages}/>
                <Route path={`${match.url}/faq/:section`} component={FAQ}/>
                <Route path={`${match.url}/faq/`} component={FAQ}/>
                <Route path={`${match.url}/contact`} component={asyncComponent(() => import('./extraPages/routes/contactUs'))}/>
                <Route path={`${match.url}/inactive`} component={asyncComponent(() => import('./extraPages/routes/inactive'))}/>


                <Route path={`${match.url}/userguide`} component={UserGuideRoutes}/>

                {/*<Route path={`${match.url}/userguide/:section`} component={UsersGuidePage}/>*/}
                {/*<Route path={`${match.url}/userguide/`} component={UsersGuidePage}/>*/}

                {/*<Route path={`${match.url}/support`}  component={SupportPages}/>*/}
                <Redirect exact from={`*`} to={`/board/settings/account`}/>

                <Route component={asyncComponent(() => import("app/routes/extraPages/routes/404"))}/>

            </Switch>
        )
    }

}

export default withRouter(Routes);

